export const LOGIN_ROUTE = '/auth/login';
export const CUSTOMER_COMPANY_ROUTE = 'gestione-cliente-azienda';
export const EMPLOYEE_ROUTE = 'gestione-dipendente';
export const OPPORTUNITIES_MANAGEMENT_ROUTE = 'gestione-annunci';
export const GOLD_OPPORTUNITIES_MANAGEMENT_ROUTE = 'gestione-annunci-gold';
export const BANK_MANAGEMENT_ROUTE = 'gestione-banca-fatturazione';
export const WORKER = 'lavoratore';
export const COMPANY = 'azienda';
export const CONTRACT_MANAGEMENT_ROUTE = 'gestione-contratti';
export const CONTROVERSY_CENTER_ROUTE = 'centro-controversie';
export const ALERT_ROUTE = 'avvisi';
export const INVITE_COLLABORATORS_ROUTE = 'invita-collaboratori';
export const WHISTLEBLOWING_ROUTE = 'whistleblowing';
export const USER_MANAGEMENT_ROUTE = 'gestione-utenti';
export const WEB_MANAGEMENT_ROUTE = 'gestione-web';
export const CHAT_ROUTE = 'chat';
export const HOME_ROUTE = CUSTOMER_COMPANY_ROUTE;

export const ORDER_ASC = 'ASC';
export const ORDER_DESC = 'DESC';

export const API_AUTH_LOGIN = '/login';
export const API_AUTH_LOGOUT = '/logout';

export const MODAL_WIDTH = '70vw';
export const BASE_MODAL_WIDTH = '60vw';
